import React from 'react'
import { TABLE_TYPE, withTableContext } from '../../context/TableContext'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useMsgsList } from '../../hooks/useMsgsList'
import { MsgsTable } from '../MsgsTable/MsgsTable'

interface iMsgsSentList {
  extSystemId: string
  extObjectId: string
  relatedId?: string
}

const MsgsSentListMin = ({ extSystemId, extObjectId, relatedId }: iMsgsSentList) => {

  const heads = [
    { id: 'deliveredAt', label: 'Datum ' },
    { id: 'state', label: '' },
    { id: 'subject', label: 'Předmět' },
    { id: 'attachment', label: '' },
    { id: 'recipientOrganizationName', label: 'Příjemce' },
  ]

  const { data, error, loading, totalCount } = useMsgsList(true, extSystemId, extObjectId, relatedId)

  const tableData = data.map(msg => ({
    id: msg.id,
    deliveredAt: msg.deliveredAt,
    subject: msg.subject,
    link_subject: EKOM_LINKS.listSent + '/' + msg.id,
    recipientOrganizationName: msg.recipientOrganizationName,
    attachment: msg.attachmentCount,
    isRead: !!msg.readsCount,
    state: msg.extType?.name,
  }))

  return (
    <MsgsTable
      loading={loading}
      error={error}
      heads={heads}
      data={tableData}
      totalCount={totalCount}
      noFilter
    />
  )
}

export default withTableContext(MsgsSentListMin, TABLE_TYPE.OUT, false)
